import { render, staticRenderFns } from "./ReportRentalObjectsSettings.vue?vue&type=template&id=edbcb744&scoped=true&"
import script from "./ReportRentalObjectsSettings.vue?vue&type=script&lang=js&"
export * from "./ReportRentalObjectsSettings.vue?vue&type=script&lang=js&"
import style0 from "./ReportRentalObjectsSettings.vue?vue&type=style&index=0&id=edbcb744&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edbcb744",
  null
  
)

export default component.exports